import { render, staticRenderFns } from "./BankAuthTimer.vue?vue&type=template&id=b673785a&scoped=true"
import script from "./BankAuthTimer.vue?vue&type=script&lang=js"
export * from "./BankAuthTimer.vue?vue&type=script&lang=js"
import style0 from "./BankAuthTimer.vue?vue&type=style&index=0&id=b673785a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b673785a",
  null
  
)

export default component.exports